import { render, staticRenderFns } from "./LocationSettingsPlatformCard.vue?vue&type=template&id=2c81af06&scoped=true"
import script from "./LocationSettingsPlatformCard.vue?vue&type=script&lang=js"
export * from "./LocationSettingsPlatformCard.vue?vue&type=script&lang=js"
import style0 from "./LocationSettingsPlatformCard.vue?vue&type=style&index=0&id=2c81af06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81af06",
  null
  
)

export default component.exports